<template>
<div>

        <div class="lp-filters">
          <span class="lps"></span>
          <form class="gen-form">
            <div class="gf-row">
              <select v-model="destination">
                <option :value="null">{{ labels.dest }}</option>
                <option v-for="destination in destinations" v-if="!destination.isSupporting" :value="destination.id">{{ destination.title }}</option>
              </select>
            </div>
            <div class="gf-row" v-for="category in categories">
              <label class="checkbox">
                <input type="checkbox" v-model="selCat" :value="category.id" />
                <em></em>
                <span>{{ category.title }}</span>
              </label>
            </div>
            <div class="gf-row">
              <a href="" class="sort-toggle" :class="{act: sortProp=='title', desc: sort=='desc'}" v-on:click.prevent="toggleSort('title')">{{ sort=='desc'?'Z-A':'A-Z' }}</a>
            </div>
<!--            <div class="gf-row">
              <a href="" class="sort-toggle" :class="{act: sortProp=='rooms', desc: sort=='desc'}" v-on:click.prevent="toggleSort('rooms')">{{ labels.rooms }}</a>
            </div>-->
            <div class="gf-row">
              <a href="" class="sort-toggle" :class="{act: sortProp=='meetingRooms', desc: sort=='desc'}" v-on:click.prevent="toggleSort('meetingRooms')">{{ labels.nomeet }}</a>
            </div>
            <div class="gf-row">
              <a href="" class="sort-toggle" :class="{act: sortProp=='plenary', desc: sort=='desc'}" v-on:click.prevent="toggleSort('plenary')">{{ labels.plenary }}</a>
            </div>
          </form>
        </div>
        <div class="boxed-list">
          <ul>
            <li v-for="item in shownItems" :class="{animated: shown}">
              <h4>{{ item.title }}</h4>
              <div class="loc">{{ item.destination }}</div>
              <div class="prop">
                <label>{{ labels.nomeet }}</label>
                <span>{{ item.meetingRooms }}</span>
              </div>
              <div class="prop">
                <label>{{ labels.plenary }}</label>
                <span>{{ item.plenary }}</span>
              </div>
              <a class="lnk-more" :href="item.link">{{ item.readmore }}</a>
              <a class="whole-link" :href="item.link"></a>
            </li>
          </ul>
        </div>

</div>
</template>
<script>
export default {
  props: ["items", "categories", "destinations"],
  data: ()=>({
    destination: null,
    selCat: [],
    sort: 'asc',
    sortProp: 'title',
    shown: false,
    labels: {
      sc: {
        dest: "Изаберите вашу дестинацију",
        all: "Све",
        rooms: "Број соба",
        plenary: "Највећа сала",
        nomeet: "Број сала"},
      sr: {
        dest: "Izaberite vašu destinaciju",
        all: "Sve",
        rooms: "Broj soba",
        plenary: "Najveća sala",
        nomeet: "Broj sala"},
      en: {
        dest: "Choose your destination",
        all: "All",
        rooms: "Number of rooms",
        plenary: "Largest plenary",
        nomeet: "Number of meeting rooms"},
    }[appLang],
  }),
  computed: {
    shownItems() {
      var items=[];
      for(var item of this.items) {
        if (this.destination && this.destination!=item.destid)
          continue;
        if (this.selCat.length && this.selCat.indexOf(item.catid)==-1)
          continue;
        if (this.sort=='asc')
          items.push(item);
        else
          items.unshift(item);
      }
      items=items.sort((a,b)=>{
        if (this.sortProp=='title') {
          if (a.title<b.title)
            return -1*(this.sort=='asc'?1:-1);
          if (a.title>b.title)
            return 1*(this.sort=='asc'?1:-1);
        } else {
          if (a[this.sortProp]*1<b[this.sortProp]*1)
            return -1*(this.sort=='asc'?1:-1);
          if (a[this.sortProp]*1>b[this.sortProp]*1)
            return 1*(this.sort=='asc'?1:-1);
        }
        return 0;
      });
      return items;
    },
  },
  methods: {
    toggleSort(prop) {
      if (this.sortProp!=prop) {
        this.sortProp=prop;
        this.sort=prop!="title"?"desc":"asc";
      } else {
        this.sort=this.sort=="asc"?"desc":"asc";
      }
    },
  },
  mounted() {
    scrollAnimations(this.$el);
    setTimeout(()=>this.shown=true, 1000);
  },
}
</script>
